import React from 'react';

import { Urls } from 'js/src/client';
import Callout, { CALLOUT_TYPES } from 'js/src/components/common/ui/Callout';
import { UPGRADE_STATUS } from 'js/src/components/pricing/types';

export function UpgradeNode(props: {
    upgradeStatus: UPGRADE_STATUS | undefined;
    planName: string | undefined;
    retryUpgradeWithNewCard: VoidFunction;
}) {
    switch (props.upgradeStatus) {
        case UPGRADE_STATUS.SUCCESS:
            if (props.planName === 'Community') {
                // downgrade
                return (
                    <Callout msgType={CALLOUT_TYPES.INFO}>
                        <strong>Plan change successful!</strong>
                        <br />
                        You are now on the <strong>Free&nbsp;Plan</strong>
                    </Callout>
                );
            } else {
                // upgrade
                return (
                    <Callout msgType={CALLOUT_TYPES.INFO}>
                        <strong>Successfully upgraded!</strong>
                        <br />
                        You are now on <strong>{props.planName}</strong>
                    </Callout>
                );
            }
        case UPGRADE_STATUS.CARD_DECLINED:
            return (
                <Callout msgType={CALLOUT_TYPES.ERROR}>
                    <strong>
                        Your card was declined.
                        <br />
                        <a onClick={props.retryUpgradeWithNewCard}>Try a different&nbsp;card</a>.
                    </strong>
                </Callout>
            );
        case UPGRADE_STATUS.TEAM_SIZE_ERROR:
            return (
                <Callout msgType={CALLOUT_TYPES.ERROR}>
                    <strong>
                        You&apos;re trying to decrease the number of users on your plan but you have
                        too many active team members. Please first remove team members to reduce
                        your team size.
                        <br />
                        <a href={Urls.TEAM_MANAGEMENT}>View team settings.</a>
                    </strong>
                </Callout>
            );
        case UPGRADE_STATUS.PERMISSION_ERROR:
            return (
                <Callout msgType={CALLOUT_TYPES.ERROR}>
                    <strong>
                        Please contact your team administrator to make changes to your plan.
                    </strong>
                </Callout>
            );
        case UPGRADE_STATUS.SCA_REQUIRED:
            return (
                <Callout msgType={CALLOUT_TYPES.ERROR}>
                    <strong>
                        Your bank requires addition authentication for this purchase. Once you
                        approve it, we will upgrade your account automatically. You can read more
                        about&nbsp;
                        <a
                            href="https://help.lumen5.com/en/article/strong-customer-authentication-to3xag/"
                            target="_blank"
                            rel="noreferrer"
                        >
                            Strong Customer Authentication here.
                        </a>
                    </strong>
                </Callout>
            );
        case UPGRADE_STATUS.GENERIC_ERROR:
            return (
                <Callout msgType={CALLOUT_TYPES.ERROR}>
                    <strong>
                        There was an error processing your payment.
                        <br />
                        Please try&nbsp;again.
                    </strong>
                </Callout>
            );
        default:
            return null;
    }
}
